// extracted by mini-css-extract-plugin
export var container = "_gw-0";
export var content = "_gw-3";
export var customerTitle = "_gw-4";
export var empty = "_gw-5";
export var gray = "_gw-6";
export var header = "_gw-7";
export var info = "_gw-8";
export var loading = "_gw-2";
export var loadingCard = "_gw-9";
export var oneLine = "_gw-a";
export var personName = "_gw-e";
export var pillContainer = "_gw-b";
export var selected = "_gw-1";
export var text = "_gw-c";
export var twoLines = "_gw-d";
export var unread = "_gw-f";
export var unreadIndicator = "_gw-g";